import React from 'react';
import './OurMissionSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';
import reflectionImage from '../../assets/images/reflection.jpg';

const OurMissionSection = () => {
  return (
    <section className="our-mission-section">
        <div className="mission-content">
          <div className="mission-text">
            <h2 className="section-label">
              <img src={greenBullet} alt="" className="bullet-image" />
              OUR MISSION
            </h2>
            <h3 className="section-headline">Unlock the upside</h3>
            <p className="section-description">
              Businesses across traditional sectors of the economy are at an inflection point. Many recognize the opportunities of the new economy but lack the know-how required to drive change. Our team of accomplished investors and senior operating executives is built to enable these businesses to achieve their full potential by helping to effect a digital transformation.
            </p>
            <a href="/approach" className="learn-more-link">
              LEARN MORE
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
          <div className="mission-image">
            <img src={reflectionImage} alt="Reflection" />
          </div>
        </div>
    </section>
  );
};

export default OurMissionSection;